import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const PUT_BENEFIT_REQUEST = "PUT_BENEFIT_REQUEST";
export const PUT_BENEFIT_SUCCESS = "PUT_BENEFIT_SUCCESS";
export const PUT_BENEFIT_ERROR = "PUT_BENEFIT_ERROR";

//* ACTIONS ------------------------------------------------
export const putBenefitRequest = (payload = {}, callback) => ({
  type: PUT_BENEFIT_REQUEST,
  payload,
  callback,
});

export const putBenefitSuccess = () => ({
  type: PUT_BENEFIT_SUCCESS,
});

export const putBenefitError = (error) => ({
  type: PUT_BENEFIT_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const putBenefitServiceRequest = async ({ benefitId, ...data }) => {
  const options = await withToken({
    method: Methods.PUT,
    headers: { CompanyId: await getUserCompany() },
    data: { ...data },
  });

  return request(`/benefits/${benefitId}`, options);
};
